export default __webpack_public_path__ + "static/media/card.5134eb53.jpg";